import { AutoComplete, Col, Icon, Row, Select, Input } from 'antd';
import classNames from 'classnames/bind';
import { ErrorText, PopDeleteConfirm } from 'components/ui/index';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import Enums from 'utils/EnumsManager';
import { ValueCriteriaField } from '../index';
import styles from './index.less';

const { Option } = Select;
const AutoOption = AutoComplete.Option;
const cx = classNames.bind(styles);
const { WorkFlow } = Enums;
const { ShortChecker, UserInput } = WorkFlow;

const sideColLayout = {
  xs: 24,
  sm: 1,
};
const colLayout = {
  xs: 24,
  sm: 7,
};
const getFieldCls = (hasError) => {
  const errorCls = hasError ? 'has-error' : '';
  return `full-width ${errorCls}`;
};


const defaultProps = {
  condition: '',
  type: '',
  value: ''
};
const propTypes = {
  intl: intlShape.isRequired,
  displayNum: PropTypes.number.isRequired,
  condition: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]),
  type: PropTypes.string,
  conditions: PropTypes.array.isRequired,
  fields: PropTypes.array.isRequired,
};


const Criterion = ({
  intl,
  criterion,

  displayNum,
  fieldId,
  conditionId,
  value,
  type,
  valueType,
  functionType,

  fields,
  conditions,
  valueTypeOptions,
  getCompareOptions,
  handleFieldChange,
  handleConditionChange,
  handleValueTypeChange,
  handleValueChange,
  handleAddonClick,
  handleFilterRemove,
  handleTimeRangeChange,
  needSearchBar,
}) => {
  const { formatMessage } = intl;
  const valueCriteriaFieldProps = {
    displayNum,
    type,
    value,
    handleValueChange,
    handleAddonClick,
    handleTimeRangeChange,
  };

  const ValueCompareSelector = () => {
    const options = getCompareOptions(fieldId, valueType);
    return (
      <Select size="small" className="full-width" value={value} onChange={v => handleValueChange(v, displayNum)}>
        {options && options.map(option => (
          <Option value={option.id} key={option.id}>
            {option.field_label}
          </Option>
        ))}
      </Select>
    );
  };

  const getValueColumn = () => {
    if (!type || !conditionId) return <span className={cx('message')}>{formatMessage({ id: 'page.filterCriteria.columns.emptyMsg' })}</span>;
    if (functionType === ShortChecker) return null;
    return (
      <Row gutter={8}>
        <Col span={6}>
          <Select size="small" className="full-width" value={valueType} onChange={v => handleValueTypeChange(displayNum, v)}>
            {valueTypeOptions.map(option => (
              <Option value={option.id} key={option.id}>
                {option.display_value}
              </Option>
            ))}
          </Select>
        </Col>
        <Col span={18}>
          {!valueType || valueType === UserInput ? <ValueCriteriaField criterion={criterion} {...valueCriteriaFieldProps} /> : ValueCompareSelector()}
        </Col>
      </Row>
    );
  };

  const renderAutoCompleteOption = item => (
    <AutoOption
      key={item.id}
      value={item.id.toString()}
      disabled={item.restriction}
      onChange={newFieldId => handleFieldChange(newFieldId, displayNum)}
    >
      {item.field_label}
    </AutoOption>
  );

  const filterAutoOption = (inputValue, option) => option.props.children.toLowerCase().trim().indexOf(inputValue.toLowerCase().trim()) > -1;

  return (
    <Row gutter={16} style={{ marginBottom: 10 }}>
      <Col {...sideColLayout} className={cx('displayNumCol')}>
        {displayNum}
      </Col>
      <Col {...colLayout}>
        {!needSearchBar &&
        <Select
          size="small"
          className={getFieldCls(fieldId === Enums.PhantomId)}
          value={fieldId === Enums.PhantomId ? '' : fieldId}
          onChange={newFieldId => handleFieldChange(newFieldId, displayNum)}
        >
          {fields.map(field => (
            <Option
              key={field.id}
              value={field.id}
            >
              {field.field_label}
            </Option>
          ))}
        </Select>
        }
        {needSearchBar &&
        <AutoComplete
          className="full-width"
          defaultValue={fieldId ? fieldId.toString() : ''}
          dataSource={fields.map(renderAutoCompleteOption)}
          filterOption={filterAutoOption}
          onSelect={newFieldId => handleFieldChange(newFieldId, displayNum)}
        >
          <Input suffix={<Icon type="search" />} />
        </AutoComplete>
          }
        {fieldId === Enums.PhantomId && <ErrorText intlId="global.errors.inputRequired" />}
      </Col>
      <Col {...colLayout}>
        <Select
          size="small"
          className={getFieldCls(conditionId === Enums.PhantomId)}
          value={conditionId === Enums.PhantomId ? '' : conditionId}
          onChange={newConditionId => handleConditionChange(newConditionId, displayNum)}
        >
          {conditions.map(condition => (
            <Option
              key={condition.id}
              value={condition.id}
            >
              {condition.display_value}
            </Option>
          ))}
        </Select>
        {conditionId === Enums.PhantomId && <ErrorText intlId="global.errors.inputRequired" />}
      </Col>
      <Col {...colLayout}>
        {getValueColumn()}
      </Col>
      <Col {...sideColLayout}>
        <PopDeleteConfirm onConfirm={() => handleFilterRemove(displayNum)}>
          <Icon className={`cursor-pointer ${cx('deleteIcon')}`} type="delete" />
        </PopDeleteConfirm>
      </Col>
    </Row>
  );
};


Criterion.defaultProps = defaultProps;
Criterion.propTypes = propTypes;
export default injectIntl(Criterion);



// WEBPACK FOOTER //
// ./src/components/page/FilterCriteria/components/Criterion/index.jsx